module.exports = __webpack_public_path__ + "media/overlays/01-0a3750e6.png";